import { ResourceProps } from 'react-admin';
import DescriptionIcon from '@mui/icons-material/Description';
import ItemCreate from './ItemCreate';
import ItemEdit from './ItemEdit';
import ItemList from './ItemList';
import { DataResourceOptions } from '../../common/types';

export const resourceProps: ResourceProps = {
  name: 'items',
  create: ItemCreate,
  edit: ItemEdit,
  icon: DescriptionIcon,
  list: ItemList,
};

export default {
  name: 'items',
  singularName: 'item',
  payloadKey: 'items',
  singularPayloadKey: 'item',
  localized: true,
} as DataResourceOptions;
